angular.module("app").controller("GamesEditPageController", [
    '$scope',
    'casinoGameService',
    'errorHandler',
    'preloadedCategories',
    'preloadedSubCategories',
    'preloadedProviders',
    'casinoGameTypes',
    '$filter',
    'ratios',
    'pageStatuses',
    'logger',
    'preloadedGameData',
    'deepCompare',
    function ($scope, casinoGameService, errorHandler, preloadedCategories, preloadedSubCategories, preloadedProviders, casinoGameTypes, $filter, ratios, pageStatuses, logger, preloadedGameData, deepCompare) {
        var init,
            types = [],
            translator = $filter('translate');

        casinoGameTypes.forEach(function (value) {
            types.push({
                id: value,
                title: translator('casinoGame.addEdit.types.' + value)
            })
        });

        $scope.ratios = ratios;

        $scope.pageStatuses = pageStatuses;

        $scope.tooltip = {
            name: "",
            height: "",
            width: "",
            downloadLinkWindows: "",
            downloadLinkLinux: "",
            downloadLinkMac: ""
        };

        $scope.save = function () {
            var fetchedData = fetchRequestData(),
                requestData = {
                    casinoGame: angular.copy(fetchedData)
                },
                changes;

            changes = deepCompare.getChanges(preloadedGameData, requestData.casinoGame);
            changes.id = preloadedGameData.id;

            changes.categories = requestData.casinoGame.categories;
            changes.subCategories = requestData.casinoGame.subCategories;
            changes.types && (changes.types = requestData.casinoGame.types);

            requestData.casinoGame = changes;

            casinoGameService.edit(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("updated");
                        preloadedGameData = angular.copy(fetchedData);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isAllowedToUpdate = function () {
            return deepCompare.isEqual(fetchRequestData(), preloadedGameData)
        };

        function fetchRequestData () {
            var fetchedData = angular.extend({}, $scope.gameData);


            fetchedData.categories = [];
            fetchedData.subCategories = [];
            fetchedData.types = [];

            $scope.multiSelect.selectedCategories.forEach(function (value) {
                fetchedData.categories.push(value.id)
            });
            $scope.multiSelect.selectedSubCategories.forEach(function (value) {
                fetchedData.subCategories.push(value.id)
            });
            $scope.multiSelect.selectedCasinoGameTypes.forEach(function (value) {
                fetchedData.types.push(value.id)
            });

            return fetchedData
        }

        (init = function (gameData) {
            var categories = [],
                subCategories = [];
            $scope.multiSelect = {
                selectedCategories: function () {
                    var fetchedData = [];
                    gameData.categories.forEach(function (category) {
                        fetchedData.push({id: category.id})
                        categories.push(category.id)
                    });
                    return fetchedData
                } (),
                selectedSubCategories: function () {
                    var fetchedData = [];
                    gameData.subCategories.forEach(function (subCategory) {
                        fetchedData.push({id: subCategory.id})
                        subCategories.push(subCategory.id)
                    });
                    return fetchedData
                } (),
                categories: angular.copy(preloadedCategories),
                subCategories: angular.copy(preloadedSubCategories),
                casinoGameTypes: types,
                selectedCasinoGameTypes: function () {
                    var fetchedData = [];
                    gameData.types.forEach(function (value) {
                        fetchedData.push({id: value})
                    });
                    return fetchedData
                } ()
            };

            $scope.providers = angular.copy(preloadedProviders);


            gameData.subCategories = angular.copy(subCategories);
            gameData.categories = angular.copy(categories);
            $scope.gameData = angular.copy(gameData);

            $scope.add_games_form && $scope.add_games_form.$setPristine()
        })(preloadedGameData)

    }
]);